import _asyncToGenerator from "/opt/build/repo/gatsby/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _toConsumableArray from "/opt/build/repo/gatsby/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/opt/build/repo/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/opt/build/repo/gatsby/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/opt/build/repo/gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/opt/build/repo/gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _regeneratorRuntime from "/opt/build/repo/gatsby/node_modules/@babel/runtime/regenerator";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var __defProp = Object.defineProperty;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};

var __publicField = function __publicField(obj, key, value) {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);

  return value;
};

var __accessCheck = function __accessCheck(obj, member, msg) {
  if (!member.has(obj)) throw TypeError("Cannot " + msg);
};

var __privateGet = function __privateGet(obj, member, getter) {
  __accessCheck(obj, member, "read from private field");

  return getter ? getter.call(obj) : member.get(obj);
};

var __privateAdd = function __privateAdd(obj, member, value) {
  if (member.has(obj)) throw TypeError("Cannot add the same private member more than once");
  member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
};

var __privateSet = function __privateSet(obj, member, value, setter) {
  __accessCheck(obj, member, "write to private field");

  setter ? setter.call(obj, value) : member.set(obj, value);
  return value;
};

var __privateMethod = function __privateMethod(obj, member, method) {
  __accessCheck(obj, member, "access private method");

  return method;
};

var _template, _prevTemplate, _prevTemplateId, _upgradeProperty, upgradeProperty_fn, _updateTemplate, updateTemplate_fn;

import { MediaStateChangeEvents } from "./constants.js";
import { globalThis, document } from "./utils/server-safe-globals.js";
import { TemplateInstance } from "./utils/template-parts.js";
import { processor } from "./utils/template-processor.js";
import { camelCase, isNumericString } from "./utils/utils.js";
export * from "./utils/template-parts.js";
var observedMediaAttributes = {
  mediatargetlivewindow: "targetlivewindow",
  mediastreamtype: "streamtype"
};
var prependTemplate = document.createElement("template");
prependTemplate.innerHTML = "\n  <style>\n    :host {\n      display: inline-block;\n      line-height: 0;\n    }\n\n    media-controller {\n      width: 100%;\n      height: 100%;\n    }\n\n    media-controller:not([mediasubtitleslist]) media-captions-selectmenu,\n    media-captions-button:not([mediasubtitleslist]),\n    media-rendition-selectmenu[mediarenditionunavailable],\n    media-audio-track-selectmenu[mediaaudiotrackunavailable],\n    media-volume-range[mediavolumeunavailable],\n    media-airplay-button[mediaairplayunavailable],\n    media-fullscreen-button[mediafullscreenunavailable],\n    media-cast-button[mediacastunavailable],\n    media-pip-button[mediapipunavailable] {\n      display: none;\n    }\n  </style>\n";

var MediaThemeElement = /*#__PURE__*/function (_globalThis$HTMLEleme) {
  _inherits(MediaThemeElement, _globalThis$HTMLEleme);

  var _super = _createSuper(MediaThemeElement);

  function MediaThemeElement() {
    var _this;

    _classCallCheck(this, MediaThemeElement);

    _this = _super.call(this);

    __privateAdd(_assertThisInitialized(_this), _upgradeProperty);

    __privateAdd(_assertThisInitialized(_this), _updateTemplate);

    __publicField(_assertThisInitialized(_this), "renderRoot");

    __publicField(_assertThisInitialized(_this), "renderer");

    __privateAdd(_assertThisInitialized(_this), _template, void 0);

    __privateAdd(_assertThisInitialized(_this), _prevTemplate, void 0);

    __privateAdd(_assertThisInitialized(_this), _prevTemplateId, void 0);

    if (_this.shadowRoot) {
      _this.renderRoot = _this.shadowRoot;
    } else {
      _this.renderRoot = _this.attachShadow({
        mode: "open"
      });

      _this.createRenderer();
    }

    var observer = new MutationObserver(function (mutationList) {
      var _a;

      if (_this.mediaController && !((_a = _this.mediaController) == null ? void 0 : _a.breakpointsComputed)) return;

      if (mutationList.some(function (mutation) {
        var target = mutation.target;
        if (target === _assertThisInitialized(_this)) return true;
        if (target.localName !== "media-controller") return false;
        if (observedMediaAttributes[mutation.attributeName]) return true;
        if (mutation.attributeName.startsWith("breakpoint")) return true;
        return false;
      })) {
        _this.render();
      }
    });
    observer.observe(_assertThisInitialized(_this), {
      attributes: true
    });
    observer.observe(_this.renderRoot, {
      attributes: true,
      subtree: true
    });

    _this.addEventListener(MediaStateChangeEvents.BREAKPOINTS_COMPUTED, _this.render);

    __privateMethod(_assertThisInitialized(_this), _upgradeProperty, upgradeProperty_fn).call(_assertThisInitialized(_this), "template");

    return _this;
  }

  _createClass(MediaThemeElement, [{
    key: "mediaController",
    get: function get() {
      return this.renderRoot.querySelector("media-controller");
    }
  }, {
    key: "template",
    get: function get() {
      var _a;

      return (_a = __privateGet(this, _template)) != null ? _a : this.constructor.template;
    },
    set: function set(element) {
      __privateSet(this, _prevTemplateId, null);

      __privateSet(this, _template, element);

      this.createRenderer();
    }
  }, {
    key: "props",
    get: function get() {
      var _a, _b, _c;

      var observedAttributes = [].concat(_toConsumableArray(Array.from((_b = (_a = this.mediaController) == null ? void 0 : _a.attributes) != null ? _b : []).filter(function (_ref) {
        var name = _ref.name;
        return observedMediaAttributes[name] || name.startsWith("breakpoint");
      })), _toConsumableArray(Array.from(this.attributes)));
      var props = {};

      var _iterator = _createForOfIteratorHelper(observedAttributes),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var attr = _step.value;
          var name = (_c = observedMediaAttributes[attr.name]) != null ? _c : camelCase(attr.name);
          var value = attr.value;

          if (value != null) {
            if (isNumericString(value)) {
              value = parseFloat(value);
            }

            props[name] = value === "" ? true : value;
          } else {
            props[name] = false;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return props;
    }
  }, {
    key: "attributeChangedCallback",
    value: function attributeChangedCallback(attrName, oldValue, newValue) {
      if (attrName === "template" && oldValue != newValue) {
        __privateMethod(this, _updateTemplate, updateTemplate_fn).call(this);
      }
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      __privateMethod(this, _updateTemplate, updateTemplate_fn).call(this);
    }
  }, {
    key: "createRenderer",
    value: function createRenderer() {
      if (this.template && this.template !== __privateGet(this, _prevTemplate)) {
        __privateSet(this, _prevTemplate, this.template);

        this.renderer = new TemplateInstance(this.template, this.props, this.constructor.processor);
        this.renderRoot.textContent = "";
        this.renderRoot.append(prependTemplate.content.cloneNode(true), this.renderer);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _a;

      (_a = this.renderer) == null ? void 0 : _a.update(this.props);
    }
  }]);

  return MediaThemeElement;
}(globalThis.HTMLElement);

_template = new WeakMap();
_prevTemplate = new WeakMap();
_prevTemplateId = new WeakMap();
_upgradeProperty = new WeakSet();

upgradeProperty_fn = function upgradeProperty_fn(prop) {
  if (Object.prototype.hasOwnProperty.call(this, prop)) {
    var value = this[prop];
    delete this[prop];
    this[prop] = value;
  }
};

_updateTemplate = new WeakSet();

updateTemplate_fn = function updateTemplate_fn() {
  var _this2 = this;

  var _a;

  var templateId = this.getAttribute("template");
  if (!templateId || templateId === __privateGet(this, _prevTemplateId)) return;
  var rootNode = this.getRootNode();
  var template = (_a = rootNode == null ? void 0 : rootNode.getElementById) == null ? void 0 : _a.call(rootNode, templateId);

  if (template) {
    __privateSet(this, _prevTemplateId, templateId);

    __privateSet(this, _template, template);

    this.createRenderer();
    return;
  }

  if (isValidUrl(templateId)) {
    __privateSet(this, _prevTemplateId, templateId);

    request(templateId).then(function (data) {
      var template2 = document.createElement("template");
      template2.innerHTML = data;

      __privateSet(_this2, _template, template2);

      _this2.createRenderer();
    }).catch(console.error);
  }
};

__publicField(MediaThemeElement, "template");

__publicField(MediaThemeElement, "observedAttributes", ["template"]);

__publicField(MediaThemeElement, "processor", processor);

function isValidUrl(url) {
  if (!/^(\/|\.\/|https?:\/\/)/.test(url)) return false;
  var base = /^https?:\/\//.test(url) ? void 0 : location.origin;

  try {
    new URL(url, base);
  } catch (e) {
    return false;
  }

  return true;
}

function request(_x) {
  return _request.apply(this, arguments);
}

function _request() {
  _request = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(resource) {
    var response;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return fetch(resource);

          case 2:
            response = _context.sent;

            if (!(response.status !== 200)) {
              _context.next = 5;
              break;
            }

            throw new Error("Failed to load resource: the server responded with a status of ".concat(response.status));

          case 5:
            return _context.abrupt("return", response.text());

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _request.apply(this, arguments);
}

if (!globalThis.customElements.get("media-theme")) {
  globalThis.customElements.define("media-theme", MediaThemeElement);
}

export { MediaThemeElement };